<template>
  <b-modal
    ref="modal"
    id="payment-modal"
    title="Submit Payment"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
  >
    <form-component v-if="showCreditOption">
      <div class="containing-card">
        <p v-if="paymentModel.can_pay_with_individual_session_credit">
          Individual Credits: <span>{{ individual_session_credits_remaining | number }}</span>
        </p>
        <p v-if="paymentModel.can_pay_with_group_credit">
          Wellbeing Workshop Credits: <span>{{ group_session_credits_remaining | number }}</span>
        </p>
      </div>

      <form
        novalidate="novalidate"
        @submit.prevent
      >
        <label class="replacement-label">Payment Type</label>
          <div class="form-row hide-label">
            <div class="col-12">
              <input-select
                id="paymentType"
                v-model="paymentType"
                v-validate="'required'"
                name="paymentType"
                data-vv-name="paymentType"
                data-vv-as="payment type"
                label="Payment Type"
                type="select"
                placeholder="Payment Type"
                required
                :error="errors.first('paymentType')"
                :options="paymentTypeOptions"
              />
            </div>
          </div>
        
      </form>
    </form-component>

    <div v-else>
      <p>To pay for this session using your credit card, click the button below.</p>
    </div>


    <template
      slot="modal-footer"
      slot-scope="{ ok, cancel }"
    >
      <button
        class="btn"
        type="button"
        @click="hide()"
      >
        Cancel
      </button>
      <button
        class="btn btn--primary"
        type="button"
        :disabled="saving"
        @click="save()"
      >
        <font-awesome-icon
          v-if="saving"
          :spin="true"
          :icon="['fas', 'spinner']"
          class="icon alt"
        />
        <span v-else-if="paymentType === 'cc' || !showCreditOption">Continue to Payment</span>
        <span v-else>Use Credits</span>
      </button>
    </template>
  </b-modal>
</template>

<script>
import Vue from 'vue';
import FormComponent from '@/components/FormComponent.vue';
import InputSelect from '@/components/inputs/InputSelect.vue';
import StudentClient from '@/api/StudentClient';

export default {
  name: 'PendingModal',
  components: {
    FormComponent,
    InputSelect,
  },
  props: {
    paymentPaidWithCredits: {
      type: Function,
    },
  },
  data() {
    return {
      saving: false,
      studentClient: new StudentClient(this.$http),

      paymentModel: null,
      individual_session_credits_remaining: 0,
      group_session_credits_remaining: 0,

      paymentType: 'credits',
      paymentTypeOptions: [{id: 'credits', display_label: 'Use Credits' }, { id: 'cc', display_label: 'Pay with Credit Card' }],
    };
  },
  computed: {
    showCreditOption() {
      return this.paymentModel && ((this.paymentModel.can_pay_with_individual_session_credit && this.individual_session_credits_remaining) || (this.paymentModel.can_pay_with_group_credit && this.group_session_credits_remaining))
    },
  },
  methods: {
    show(paymentModel, individual_session_credits_remaining, group_session_credits_remaining) {
      this.$refs.modal.show();
      this.saving = false;
      this.paymentType = 'credits';

      this.paymentModel = paymentModel;
      this.individual_session_credits_remaining = individual_session_credits_remaining;
      this.group_session_credits_remaining = group_session_credits_remaining;
    },

    hide() {
      this.$refs.modal.hide();
    },

    save() {
      let payWithCredits = false;

      if (this.showCreditOption) {
        payWithCredits = this.paymentType === 'credits';
      }

      this.saving = true;
      if (payWithCredits) {
        this.studentClient.payForSessionWithCredit(this.paymentModel.id).then(res => {
          this.saving = false;
          this.hide();
          this.paymentPaidWithCredits(this.paymentModel.id);
        }).catch(ex => {
          this.$store.commit('setGlobalAlert', {
            msg: 'Failed to submit payment. Please try again!', error: true,
          });
          this.saving = false;
        });
      } else {
        const success_url = this.paymentModel.stripeSuccessUrl;
        const cancel_url = this.paymentModel.stripeErrorUrl;
        this.studentClient.payForSessionWithStripe(this.paymentModel.id, success_url, cancel_url).then(res => {
          if (res && res.stripe_checkout_session_id) {
            const stripe = window.Stripe(Vue.prototype.$globalEnv.stripe);
            stripe.redirectToCheckout({
              sessionId: res.stripe_checkout_session_id,
            }).then(function (result) {
              if (result && result.error) {
                this.$store.commit('setGlobalAlert', {
                  msg: 'Failed to submit payment. Please try again!', error: true,
                });
                this.saving = false;
              }
            });
          } else {
            this.$store.commit('setGlobalAlert', {
              msg: 'Failed to submit payment. Please try again!', error: true,
            });
            this.saving = false;
          }
        }).catch(ex => {

        });
      }

    },
  },
};
</script>

<style lang="scss">

</style>
